/**
 * Created by satish krishnamurthy on 25/10/17.
 */
import React, { Component } from 'react';

export default class AddToHomeScreen extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    let aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = "https://cdn.rawgit.com/cubiq/add-to-homescreen/master/src/addtohomescreen.min.js";

    document.head.appendChild(aScript);
    aScript.onload = function() {
      //run addToHomescreen method from addtohomescreen.min.js
      // let iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      if(localStorage.getItem('isBookmarked') === null) {
        addToHomescreen({
          lifespan: 0,
          onAdd : function() {
            localStorage.setItem('isBookmarked', 'true')
          },
        });
      }
    };
  }

  render() {
    return null;
  }
}
